<template>
    <label class="label-form"><span v-if="required" class="label-form-required">*</span> {{ label }}</label>
</template>

<script>
export default {
    name: "LabelForm",
    props: {
        label: String,
        required: Boolean
    }
}
</script>

<style scoped>
    .label-form {
        /*font-weight: 500;*/
        color: rgba(0, 0, 0, 0.85);
    }

    .label-form-required {
        color: #f5222d;
    }
</style>
